

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';
@Injectable({
  providedIn: 'root',
})
export class ProfileService extends ApiService {


    public updateProfile(body): Observable<any> {
      return this.request({
        path: 'users/profile',
        method: 'PUT',
        body: body
      });
    }


}
